define('modules/private/index',['require','exports','module','./model','./view-mdReminders','./view-mdheader','./view-mdsidebar','../../helpers/RemindersHelper','env','../../helpers/raven'],function (require, exports, module) {
  "use strict";

  var MeModel = require("./model"),
    MDReminders = require("./view-mdReminders"),
    MDHeaderJS = require("./view-mdheader"),
    MDSidebarJS = require("./view-mdsidebar"),
    RemindersHelper = require("../../helpers/RemindersHelper"),
    Config = require("env");

  var isBeta = function () {
    return navigator.userAgent.indexOf("MDirector") !== -1;
  };

  var isSidebarCollapsed = function () {
    var currentPath = Backbone.history.location.pathname;
    return currentPath.startsWith("/accounts");
  };

  var RavenHelper = require("../../helpers/raven");

  var me, privateHeaderView;

  var initHeaderView = function (options, me) {
    var MainView = MDHeaderJS;

    return new MainView({
      el: options && options.el ? options.el : "#header",
      model: me,
      options: options,
      showCompanies: false,
    });
  };

  var init = function (afterRenderCallback, options) {
    var initMe = !me;

    if (initMe) {
      me = new MeModel();
    }

    privateHeaderView = this.initHeaderView(options, me);
    privateHeaderView.options.afterRenderCallback = function () {
      if (afterRenderCallback) {
        afterRenderCallback(me);
      }
      RavenHelper.setUserContext(me);
    };
    privateHeaderView.loadData();
    var MDSidebar = new MDSidebarJS({ model: me });

    if (initMe) {
      return me.fetch({
        error: function (model, response) {
          var redirectUrl = Config.backendUrl + "/auth/logout";
          location.href = redirectUrl;
        },
        success: function () {
          if (isSidebarCollapsed()) {
            MDSidebar.collapseSidebar();
          }
        },
      });
    }

    return true;
  };

  var showReminderNoBillingDetails = function () {
    return new MDReminders({
      el: "#md__reminders",
      reminderData: RemindersHelper.getUserNotBillingDetailsParams(),
    }).render();
  };

  var showReminderUserNewFree = function () {
    return new MDReminders({
      el: "#md__reminders",
      reminderData: RemindersHelper.getUserNewFreeParams(),
    }).render();
  };

  module.exports = {
    Model: MeModel,

    getMe: function () {
      return me;
    },

    init: init,
    initHeaderView: initHeaderView,

    showHeader: function () {
      if (!isBeta()) privateHeaderView.showHeader();
    },

    showReminderNoBillingDetails: showReminderNoBillingDetails,
    showReminderUserNewFree: showReminderUserNewFree,
  };
});

